import { Descriptions as DescriptionsAnt } from 'antd-v5';
import styled from 'styled-components';
import { Flex } from 'UI/Flex';

export const SDescriptions = styled(DescriptionsAnt)`
  .ant5-descriptions-row,
  .ant5-descriptions-row > th.ant5-descriptions-item-label,
  .ant5-descriptions-row > td.ant5-descriptions-item-content {
    background-color: ${({ theme }) => theme.color.grey95} !important;
    border: none;
    height: 28px;
    padding-bottom: 0 !important;
    padding-top: 0 !important;
    width: calc(25%);
  }

  .ant5-descriptions-row:nth-child(even) > th.ant5-descriptions-item-label,
  .ant5-descriptions-row:nth-child(even) > td.ant5-descriptions-item-content {
    background-color: white !important;
  }

  .ant5-descriptions-header {
    margin-bottom: 10px !important;
    margin-top: 0 !important;
    margin-left: 15px;
  }
`;

export const ShowMoreButtonWrapper = styled(Flex)`
  z-index: 1;
`;
